export class ProblemDetails<T> {
  private data: any;
  private keys: string[];
  private values: string[];

  constructor(data: any) {
    this.data = data;
    this.keys = Object.keys(data);
    this.values = Object.values(data);

    this._MODEL = ({} as T);
    for (const key of this.keys) {
      const splits = key.split('.').map(s => s.charAt(0).toLowerCase() + s.substr(1));
      let current = this._MODEL;
      for (let i = 0; i < splits.length - 1; i++) {
        const split = splits[i].toLowerCase();
        current[split] = current[split] || {};
        current = current[split];
      }
      current[splits[splits.length - 1]] = data[key];
    }
  }

  private _MODEL: T;

  get MODEL() {
    return this._MODEL;
  }
}
